module.exports = __webpack_public_path__ + "static/media/logo-cc.e792b7ed.svg";